<div class="toolbar" [class.hidden]="!toolbarVisible">
  <div class="toolbar-left">
    <button (click)="onToggleGraph()" [attr.title]="t.TOOLTIP_TOGGLE_DASHBOARD">
      <i class="bi bi-layout-sidebar"></i>
    </button>
  </div>

  <div class="toolbar-right">
    <button
      (click)="toggleTheme()"
      [attr.title]="t.TOOLTIP_TOGGLE_THEME"
      class="theme-toggle-btn"
    >
      <i
        class="bi"
        [ngClass]="
          themeService.isDark()
            ? 'bi-moon-stars-fill'
            : 'bi-brightness-high-fill'
        "
      ></i>
    </button>

    <input
      *ngIf="searchActive"
      type="text"
      [(ngModel)]="searchQuery"
      (input)="onSearchChange($event)"
      [attr.placeholder]="t.PLACEHOLDER_SEARCH_APPLICATIONS"
      class="search-input"
    />
  </div>
</div>

<button class="search-fab" (click)="toggleSearch()" [attr.title]="t.TOOLTIP_SEARCH">
  <i [ngClass]="searchActive ? 'bi bi-x-circle' : 'bi bi-search'"></i>
</button>
<button class="fab" (click)="addNewApplication()">
  <i class="bi bi-plus"></i>
</button>

